.DataPills {
  display: flex;
  flex-flow: row wrap;
  gap: 15px;
  margin-bottom: 15px;
}

.DataPills > * {
  border: 1px solid var(--bs-border-color);
  border-radius: 15px;
  padding: 5px 15px;
}
